import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
    html{
        font-size: 62.5%;
        font-family: "Inter";
    }
`;

export default GlobalStyles;
